// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5822ecbc] .p-colorpicker-preview {\n  height: 1.7rem !important;\n}\n.block-plotly[data-v-5822ecbc] {\n  height: 560px;\n  width: 125rem;\n}\nh3[data-v-5822ecbc] {\n  margin: 40px 0 0;\n}\nul[data-v-5822ecbc] {\n  list-style-type: none;\n  padding: 0;\n}\nli[data-v-5822ecbc] {\n  display: inline-block;\n  margin: 0 10px;\n}\na[data-v-5822ecbc] {\n  color: #42b983;\n}", ""]);
// Exports
module.exports = exports;
